import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import logo from "../../Assets/images/ConnectHealthPro.png";
import { get, put, del, post } from '../../utility/fetch';
import { get as gets, put as puts, del as dels, post as posts } from '../../utility/fetch';

import notification from '../../utility/notification';
import { Button, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, Typography, Chip, Box } from '@mui/material';
import { UserContext } from '../../contexts/UserContext';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate, useLocation } from 'react-router-dom';
import PromoBanner from '../Layout/PromoBanner';
import PhoneInput from '../inputs/PhoneInput';
import ImmunizationTable from '../tables/ImmunizationTable';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function HealthRecord() {
    const [selectedSidebarItem, setSelectedSidebarItem] = useState('referralLink');
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);
    const [formData, setFormData] = useState({
        fullName: '',
        firstName: '',
        middleName: '',
        lastName: '',
        title: '',
        email: '',
        gender: '',
        dateOfBirth: '',
        nationality: '',
        nationalityId: null,
        geoNationality: '',
        geoState: '',
        stateOfOrigin: '',
        stateId: null,
        lga: ' ',
        city: '',
        placeOfBirth: '',
        maritalStatus: '',
        identityType: ' ',
        identificationNo: '',
        govtIssuedID: '',
        govtIssuedIDType: null,
        weight: '',
        bvn: '',
        connectionMeans: ' ',
        phoneNumber: '',
        officeAddress: '',
        description: '',
        profileType: null,
        specialtyId: null,
        companyLogoUrl: '',
        associatedClinics: [],
        spokenLanguages: [],
        workSchedule: []
    });
    const [selectedDate, setSelectedDate] = useState(
        formData?.dateOfBirth ? formData?.dateOfBirth.split('T')[0] : null
    );
    const [states, setStates] = useState([]);
    const [nationalities, setNationalities] = useState([]);
    const [cities, setCities] = useState([]);
    const [titleOptions] = useState(['Mr', 'Mrs', 'Ms', 'Dr', 'Prof']);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('info');
    const [currentMedication, setCurrentMedication] = useState(null);
    const [immunization, setImmunization] = useState([]);
    const [immunizationLoading, setImmunizationLoading] = useState(false);
    const [immunizationPage, setImmunizationPage] = useState(1);
    const [immunizationTotalPages, setImmunizationTotalPages] = useState(1);
    const immunizationPageSize = 10;
    const [medicalRecords, setMedicalRecords] = useState([]);
    const [allergies, setAllergies] = useState([]);
    const [userAllergies, setUserAllergies] = useState([]);
    const [userOtherAllergies, setUserOtherAllergies] = useState([]);
    const [allergyModalOpen, setAllergyModalOpen] = useState(false);
    const [deleteAllergyModalOpen, setDeleteAllergyModalOpen] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);
    const [deleteType, setDeleteType] = useState(null); // 'allergy' or 'other'
    const [selectedAllergies, setSelectedAllergies] = useState([]);
    const [customAllergies, setCustomAllergies] = useState(['']);
    const [loadingAllergies, setLoadingAllergies] = useState(false);
    const [savingAllergies, setSavingAllergies] = useState(false);
    const [deletingAllergy, setDeletingAllergy] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [contactDetails, setContactDetails] = useState(null);
    const [emergencyContactDetails, setEmergencyContactDetails] = useState(null);
    const { profilePicture } = useContext(UserContext)
    const [savingStatus, setSavingStatus] = useState({
        personalInfo: false,
        contactDetails: false,
        emergencyContact: false
    });
    const navigate = useNavigate();
    const location = useLocation();

    // Geography base URL - try multiple env var names for compatibility
    const GEO_BASE = (
        process.env.REACT_BACKEND_URLWEB ||
        process.env.REACT_APP_BACKEND_URLWEB ||
        process.env.REACT_APP_BACKEND_URL_WEB ||
        process.env.REACT_APP_BACKEND_URL ||
        ''
    ).replace(/\/+$/, '');
    const [targetedAds, setTargetedAds] = useState([]);
    const [targetedAdsAll, setTargetedAdsAll] = useState([]);
    const [referralsCount, setReferralsCount] = useState(0);
    const [referralsLoading, setReferralsLoading] = useState(false);

    // Sync selectedDate with formData.dateOfBirth when form is loaded from API
    useEffect(() => {
        if (formData.dateOfBirth && !selectedDate) {
            try {
                const date = new Date(formData.dateOfBirth);
                setSelectedDate(date);
            } catch (e) {
                console.error('Invalid date format:', formData.dateOfBirth);
            }
        }
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // If navigated with a desired openSection, focus the right tab/sidebar
    useEffect(() => {
        const openSection = location.state?.openSection;
        if (!openSection) return;

        switch (openSection) {
            case 'personal':
            case 'identity':
            case 'demographics':
            case 'location':
                setSelectedSidebarItem('personalInfo');
                setSelectedTabIndex(0);
                break;
            case 'contact':
                setSelectedSidebarItem('contactDetails');
                setSelectedTabIndex(0);
                break;
            case 'medical':
                setSelectedSidebarItem('personalInfo');
                setSelectedTabIndex(2); // Medical Records tab
                break;
            case 'immunizations':
                setSelectedTabIndex(1);
                break;
            case 'allergies':
                setSelectedTabIndex(3);
                break;
            default:
                break;
        }

        // clear the navigation state so it doesn't re-trigger on refresh
        try { window.history.replaceState({}, document.title, window.location.pathname); } catch (e) { }
    }, [location.state]);

    const handleSidebarItemClick = (item) => {
        setSelectedSidebarItem(item);
        if (item === 'personalInfo') {
            setSelectedTabIndex(0);
        }
    };

    const getCities = async (stateId) => {
        try {
            if (!stateId) {
                setCities([]);
                return [];
            }
            if (!GEO_BASE) {
                console.warn('Geography base URL not set - cannot load cities');
                return [];
            }
            const res = await axios.get(`${GEO_BASE}/Geography/states/${stateId}/cities`);
            const list = Array.isArray(res?.data) ? res.data : (res?.data?.data || []);
            setCities(list);
            return list;
        } catch (error) {
            console.error("Error fetching cities:", error);
            notification({ message: "Failed to load cities.", type: "error" });
            return [];
        }
    };

    const handleContactChange = (e) => {
        const { name, value } = e.target;
        setContactDetails((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleEmergencyChange = (e) => {
        const { name, value } = e.target;
        setEmergencyContactDetails((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleTabChange = (newValue) => {
        setSelectedTabIndex(newValue);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleDateChange = (date) => {
        setSelectedDate(date);   // always update the Date object state

        if (date) {
            // Store ISO date string without time (YYYY-MM-DD)
            const isoDate = date.toISOString().split('T')[0];
            setFormData(prev => ({
                ...prev,
                dateOfBirth: isoDate
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                dateOfBirth: ''
            }));
        }
    };

    const getTargetedAdsAll = async () => {
        try {
            const userId = sessionStorage.getItem('userId');
            const pageName = 'All Locations';
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/connecthealthadmin/api/ad/find-ad?Id=${userId}&page=${pageName}`);

            if (response.ok) {
                const data = await response.json();
                const transformedAds = data.map(ad => ({
                    id: ad.id,
                    imageUrl: ad.bannerImageUrl,
                    title: ad.title,
                    subtitle: ad.description,
                    redirectUrl: ad.redirectUrl,
                    status: 1,
                    isTargeted: true
                }));
                setTargetedAdsAll(transformedAds);
            }
        } catch (error) {
            console.error('Error fetching targeted ads:', error);
            setTargetedAdsAll([]);
        }
    };

    const updatePersonalInfo = async () => {
        const userId = sessionStorage.getItem("userId");

        // Format date to DD-MM-YYYY
        const formatDateToDDMMYYYY = (dateString) => {
            if (!dateString) return null;
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
        };

        const payload = {
            dateOfBirth: formatDateToDDMMYYYY(formData?.dateOfBirth),
            email: formData?.email || '',
            firstName: formData?.firstName || formData?.fullName?.split(' ')[0] || '',
            lastName: formData?.lastName || formData?.fullName?.split(' ')[1] || '',
            middleName: formData?.middleName || '',
            title: formData?.title || '',
            gender: formData?.gender || '',
            phoneNumber: formData?.phoneNumber || '',
            placeOfBirth: formData?.placeOfBirth || '',
            govtIssuedID: formData?.govtIssuedID || formData?.identificationNo || '',
            govtIssuedIDType: formData?.govtIssuedIDType || 0,
            stateId: formData?.stateId || 1,
            nationalityId: formData?.nationalityId || 19,
            geoNationality: formData?.geoNationality || '',
            geoState: formData?.geoState || '',
            city: formData?.city || '',
            lga: formData?.lga || '',
            officeAddress: formData?.officeAddress || '',
            description: formData?.description || '',
            profileType: formData?.profileType || 0,
            specialtyId: formData?.specialtyId || 0,
            companyLogoUrl: formData?.companyLogoUrl || profilePicture || 0,
            associatedClinics: formData?.associatedClinics || [],
            spokenLanguages: formData?.spokenLanguages || [],
            workSchedule: formData?.workSchedule || []
        };

        try {
            const response = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/employee/${userId}`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error updating personal info:', error);
            throw error;
        }
    };



    const handleSavePersonalInfo = async () => {
        // Validate required fields
        const requiredFields = [
            { field: 'title', label: 'Title', minLength: 2, maxLength: 100 },
            { field: 'firstName', label: 'First Name', minLength: 2, maxLength: 100 },
            { field: 'lastName', label: 'Last Name', minLength: 2, maxLength: 100 },
            { field: 'email', label: 'Email' },
            { field: 'gender', label: 'Gender' },
            { field: 'dateOfBirth', label: 'Date of Birth' },
            { field: 'phoneNumber', label: 'Phone Number', maxLength: 14 },
            { field: 'placeOfBirth', label: 'Place of Birth' }
        ];

        // Check for empty required fields
        for (const { field, label, minLength, maxLength } of requiredFields) {
            const value = formData?.[field];

            if (!value || value.toString().trim() === '') {
                setSnackbarMessage(`${label} is required`);
                setSnackbarSeverity('error');
                setSnackbarOpen(true);
                return;
            }

            // Check min length
            if (minLength && value.toString().length < minLength) {
                setSnackbarMessage(`${label} must be at least ${minLength} characters`);
                setSnackbarSeverity('error');
                setSnackbarOpen(true);
                return;
            }

            // Check max length
            if (maxLength && value.toString().length > maxLength) {
                setSnackbarMessage(`${label} must not exceed ${maxLength} characters`);
                setSnackbarSeverity('error');
                setSnackbarOpen(true);
                return;
            }
        }

        // Validate email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData?.email)) {
            setSnackbarMessage('Please enter a valid email address');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            return;
        }

        // Validate date format (DD-MM-YYYY)
        const dateRegex = /^([0-2]?[1-9]|3[0-1])-([0]?[1-9]|1[0-2])-\d{4}$/;
        const dateValue = formData?.dateOfBirth ? formData.dateOfBirth.split('T')[0] : '';

        // Convert YYYY-MM-DD to DD-MM-YYYY for validation
        if (dateValue) {
            const [year, month, day] = dateValue.split('-');
            const formattedDate = `${day}-${month}-${year}`;
            if (!dateRegex.test(formattedDate)) {
                setSnackbarMessage('Date of Birth must be in DD-MM-YYYY format');
                setSnackbarSeverity('error');
                setSnackbarOpen(true);
                return;
            }
        }

        setSavingStatus(prev => ({ ...prev, personalInfo: true }));
        try {
            await updatePersonalInfo();
            setSnackbarMessage('Personal information saved successfully!');
            setSnackbarSeverity('success');
            // update session storage flags for profile completion fallback
            try {
                sessionStorage.setItem('isPersonalInfoCompleted', 'true');
                if (formData?.identificationNo) sessionStorage.setItem('isIdentityCompleted', 'true');
                if (formData?.dateOfBirth || formData?.gender || formData?.geoNationality) sessionStorage.setItem('isDemographicsCompleted', 'true');
                if (formData?.geoState || formData?.placeOfBirth || formData?.lga) sessionStorage.setItem('isLocationCompleted', 'true');
                try { window.dispatchEvent(new Event('profileUpdated')); } catch (e) { }
            } catch (e) {
                // ignore session storage errors
            }
        } catch (error) {
            console.error(error);
            setSnackbarMessage('Failed to save personal information');
            setSnackbarSeverity('error');
        } finally {
            setSavingStatus(prev => ({ ...prev, personalInfo: false }));
            setSnackbarOpen(true);
        }
    };



    const getStates = async (countryId) => {
        try {
            if (!GEO_BASE) {
                console.warn('Geography base URL not set - cannot load states');
                return;
            }
            const res = await axios.get(`${GEO_BASE}/Geography/countries/${countryId}/states`);
            const list = Array.isArray(res?.data) ? res.data : (res?.data?.data || []);
            setStates(list);
            return list;
        } catch (error) {
            console.error("Error fetching states:", error);
            notification({ message: "Failed to load states.", type: "error" });
            return [];
        }
    };

    const getNationalities = async () => {
        try {
            if (!GEO_BASE) {
                console.warn('Geography base URL not set - cannot load nationalities');
                return [];
            }
            const res = await axios.get(`${GEO_BASE}/Geography/countries`);
            const list = Array.isArray(res?.data) ? res.data : (res?.data?.data || []);
            setNationalities(list);
            return list;
        } catch (error) {
            console.error("Error fetching nationalities:", error);
            notification({ message: "Failed to load nationalities.", type: "error" });
            return [];
        }
    };


    // Handle delete confirmation
    const handleDeleteConfirmation = (type, target) => {
        setDeleteType(type);
        setDeleteTarget(target);
        setDeleteAllergyModalOpen(true);
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    const getTargetedAds = async () => {
        try {
            const userId = sessionStorage.getItem('userId');
            const pageName = 'Allergies Screen';
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/connecthealthadmin/api/ad/find-ad?Id=${userId}&page=${pageName}`);

            if (response.ok) {
                const data = await response.json();
                const transformedAds = data.map(ad => ({
                    id: ad.id,
                    imageUrl: ad.bannerImageUrl,
                    title: ad.title,
                    subtitle: ad.description,
                    redirectUrl: ad.redirectUrl,
                    status: 1,
                    isTargeted: true
                }));
                setTargetedAds(transformedAds);
            }
        } catch (error) {
            console.error('Error fetching targeted ads:', error);
            setTargetedAds([]);
        }
    };

    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                const userId = sessionStorage.getItem("userId");
                let res = await get(`/employee/employee/${userId}`);

                if (res?.data) {
                    const data = res.data;
                    console.log('Fetched profile data:', data);
                    console.log('nationality from API:', data.nationality);
                    console.log('state from API:', data.state);

                    // Format date from DD-MM-YYYY to YYYY-MM-DD for date input
                    const formatDateToYYYYMMDD = (dateString) => {
                        if (!dateString) return '';
                        // Check if already in YYYY-MM-DD format
                        if (dateString.includes('-') && dateString.split('-')[0].length === 4) {
                            return dateString.split('T')[0];
                        }
                        // Convert from DD-MM-YYYY to YYYY-MM-DD
                        const parts = dateString.split('-');
                        if (parts.length === 3) {
                            return `${parts[2]}-${parts[1]}-${parts[0]}`;
                        }
                        return '';
                    };

                    // Extract IDs and fallback names from payload (API may provide object or primitive)
                    const nationalityId = typeof data.nationality === 'object' && data.nationality?.id
                        ? data.nationality.id
                        : (typeof data.nationality === 'number' ? data.nationality : null);

                    const stateId = typeof data.state === 'object' && data.state?.id
                        ? data.state.id
                        : (typeof data.state === 'number' ? data.state : null);

                    const nationalityNameFromPayload = typeof data.nationality === 'object' && data.nationality?.name
                        ? data.nationality.name
                        : (typeof data.nationality === 'string' ? data.nationality : '');

                    const stateNameFromPayload = typeof data.state === 'object' && data.state?.name
                        ? data.state.name
                        : (typeof data.state === 'string' ? data.state : '');

                    console.log('Extracted nationalityId:', nationalityId, 'stateId:', stateId);

                    // Initialize form using payload fallbacks; we'll overwrite geo fields after fetching geography endpoints
                    setFormData({
                        fullName: `${data.firstName || ''} ${data.middleName || ''} ${data.lastName || ''}`.trim(),
                        firstName: data.firstName || '',
                        middleName: data.middleName || '',
                        lastName: data.lastName || '',
                        title: data.title || '',
                        email: data.email || '',
                        gender: data.gender || '',
                        dateOfBirth: formatDateToYYYYMMDD(data.dateOfBirth),
                        geoNationality: data?.geoNationality || nationalityNameFromPayload,
                        nationalityId: nationalityId,
                        stateOfOrigin: data.stateOfOrigin || '',
                        geoState: data?.geoState || stateNameFromPayload,
                        stateId: stateId || 1,
                        lga: data.lga || '',
                        city: data.city || '',
                        placeOfBirth: data.placeOfBirth || '',
                        maritalStatus: data.maritalStatus || '',
                        identityType: '',
                        identificationNo: data.govtIssuedID || '',
                        govtIssuedID: data.govtIssuedID || '',
                        govtIssuedIDType: data.govtIssuedIDType || null,
                        weight: data.weight || '',
                        bvn: data.bvn || '',
                        connectionMeans: '',
                        phoneNumber: data.phoneNumber || '',
                        officeAddress: data.officeAddress || '',
                        description: data.description || '',
                        profileType: data.profileType || null,
                        specialtyId: data.specialtyId || null,
                        companyLogoUrl: data.companyLogoUrl || '',
                        associatedClinics: data.associatedClinics || [],
                        spokenLanguages: data.spokenLanguages || [],
                        workSchedule: data.workSchedule || []
                    });

                    const initialDateStr = formatDateToYYYYMMDD(data.dateOfBirth);
                    if (initialDateStr) {
                        const parsed = new Date(initialDateStr);
                        if (!isNaN(parsed.getTime())) {           // valid date
                            setSelectedDate(parsed);
                        } else {
                            console.warn("Could not parse date:", data.dateOfBirth);
                            setSelectedDate(null);
                        }
                    } else {
                        setSelectedDate(null);
                    }

                    console.log('Set formData with nationalityId:', nationalityId, 'stateId:', stateId);

                    // Fetch geography endpoints (countries, states, cities) using axios and REACT_BACKEND_URLWEB
                    try {
                        const geoBase = GEO_BASE;
                        if (!geoBase) {
                            console.warn('Geography base URL not set - using payload names');
                        } else {
                            const base = geoBase;

                            // 1) countries
                            const countriesResp = await axios.get(`${base}/Geography/countries`);
                            const countries = Array.isArray(countriesResp?.data) ? countriesResp.data : (countriesResp?.data?.data || []);

                            // resolve country
                            let resolvedCountry = null;
                            if (nationalityId) resolvedCountry = countries.find(c => c.id === nationalityId);
                            if (!resolvedCountry && nationalityNameFromPayload) resolvedCountry = countries.find(c => String(c.name).toLowerCase() === String(nationalityNameFromPayload).toLowerCase());
                            const resolvedCountryName = resolvedCountry?.name || nationalityNameFromPayload || '';

                            // 2) states for country
                            let resolvedStateName = stateNameFromPayload || '';
                            if (resolvedCountry?.id) {
                                const statesResp = await axios.get(`${base}/Geography/countries/${resolvedCountry.id}/states`);
                                const statesList = Array.isArray(statesResp?.data) ? statesResp.data : (statesResp?.data?.data || []);
                                setStates(statesList);

                                let resolvedState = null;
                                if (stateId) resolvedState = statesList.find(s => s.id === stateId);
                                if (!resolvedState && stateNameFromPayload) resolvedState = statesList.find(s => String(s.name).toLowerCase() === String(stateNameFromPayload).toLowerCase());

                                if (resolvedState) {
                                    resolvedStateName = resolvedState.name;

                                    // 3) cities for state
                                    const citiesResp = await axios.get(`${base}/Geography/states/${resolvedState.id}/cities`);
                                    const citiesList = Array.isArray(citiesResp?.data) ? citiesResp.data : (citiesResp?.data?.data || []);
                                    setCities(citiesList);

                                    // determine city name (prefer payload.city matched to cities list)
                                    let resolvedCityName = data.city || '';
                                    if (resolvedCityName) {
                                        const foundCity = citiesList.find(c => String(c.name).toLowerCase() === String(resolvedCityName).toLowerCase());
                                        if (foundCity) resolvedCityName = foundCity.name;
                                    } else if (citiesList.length === 1) {
                                        resolvedCityName = citiesList[0].name;
                                    }

                                    // Update geo fields (leave placeOfBirth as-is). Keep IDs null per request.
                                    setFormData(prev => ({
                                        ...prev,
                                        geoNationality: resolvedCountryName,
                                        nationalityId: null,
                                        geoState: resolvedStateName,
                                        stateId: null,
                                        city: resolvedCityName || prev.city || ''
                                    }));
                                } else {
                                    // only country resolved
                                    setFormData(prev => ({ ...prev, geoNationality: resolvedCountryName }));
                                }
                            } else {
                                // couldn't resolve country, fallback to payload values
                                setFormData(prev => ({ ...prev, geoNationality: nationalityNameFromPayload, geoState: stateNameFromPayload, city: prev.city || data.city || '' }));
                            }
                        }
                    } catch (geoErr) {
                        console.error('Error fetching geography endpoints:', geoErr);
                        setFormData(prev => ({ ...prev, geoNationality: nationalityNameFromPayload, geoState: stateNameFromPayload, city: prev.city || data.city || '' }));
                    }
                } else {
                    notification({ type: 'error', message: 'Failed to get profile data!', duration: 3000 });
                }
            } catch (error) {
                console.error('Error fetching profile:', error);
                notification({ type: 'error', message: 'Failed to load profile information!', duration: 3000 });
            }
        };

        const initializeData = async () => {
            // First load the dropdown options
            await Promise.all([
                getNationalities()
            ]);
            // Then load the profile data
            await fetchProfileData();
        };

        initializeData();
        getTargetedAds();
        getTargetedAdsAll();
        fetchReferralSummary();
    }, []);

    const fetchReferralSummary = async () => {
        try {
            setReferralsLoading(true);
            const userId = sessionStorage.getItem('userId');
            const token = sessionStorage.getItem('token');
            const baseUrl = process.env.REACT_APP_BACKEND_URL_ADMIN;

            if (!baseUrl) {
                console.warn('Base URL not configured (REACT_APP_BASE_URL)');
                setReferralsCount(0);
                return;
            }

            // Using the correct endpoint format with query parameters
            const pageNumber = 1;
            const pageSize = 10;
            const url = `${baseUrl.replace(/\/+$/, '')}/patient/list/agents?referrerId=${userId}&pageNumber=${pageNumber}&pageSize=${pageSize}`;

            const headers = token ? { Authorization: `Bearer ${token}` } : {};
            const resp = await axios.get(url, { headers });

            console.log('Referral response:', resp.data);

            // Extract totalCount from the response
            const data = resp?.data || {};
            const count = data?.totalCount || 0;

            setReferralsCount(Number(count));
        } catch (error) {
            console.error('Failed to fetch referrals summary', error?.response || error.message || error);
            setReferralsCount(0);
        } finally {
            setReferralsLoading(false);
        }
    };

    const sidebarItems = [
        {
            text: 'Personal Information',
            icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="currentColor" />
            </svg>,
            key: 'personalInfo'
        },
        // { 
        //     text: 'Contact Details', 
        //     icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        //         <path d="M6.62 10.79C8.06 13.62 10.38 15.94 13.21 17.38L15.41 15.18C15.69 14.9 16.08 14.82 16.43 14.93C17.55 15.3 18.75 15.5 20 15.5C20.55 15.5 21 15.95 21 16.5V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z" fill="currentColor"/>
        //     </svg>, 
        //     key: 'contactDetails' 
        // },
        // { 
        //     text: 'Emergency Contact', 
        //     icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        //         <path d="M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z" fill="currentColor"/>
        //     </svg>, 
        //     key: 'emergencyContact' 
        // },
        {
            text: 'Referral Link',
            icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.9 12C3.9 10.29 5.29 8.9 7 8.9H11V7H7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17H11V15.1H7C5.29 15.1 3.9 13.71 3.9 12ZM8 13H16V11H8V13ZM17 7H13V8.9H17C18.71 8.9 20.1 10.29 20.1 12C20.1 13.71 18.71 15.1 17 15.1H13V17H17C19.76 17 22 14.76 22 12C22 9.24 19.76 7 17 7Z" fill="currentColor" />
            </svg>,
            key: 'referralLink'
        },
    ];


    const tabLabels = [
        {
            label: 'Personal Details',
            icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="currentColor" />
            </svg>
        },

    ];

    // Generate referral links with plain userId as referral code
    const userId = sessionStorage.getItem("userId");
    const [selectedReferralType, setSelectedReferralType] = useState('platform');
    const referralLinks = {
        platform: `https://platform.connecthealthpro.com/create-account?userID=${userId}&userType=2`,
        practitioners: `https://practitioners.connecthealthpro.com/create-account?userID=${userId}&userType=2`
    };
    const referralLink = referralLinks[selectedReferralType];

    const styles = {
        formGroup: {
            marginBottom: '16px',
            display: 'flex',
            flexDirection: 'column'
        },
        label: {
            marginBottom: '8px',
            color: '#6c757d',
            fontSize: '0.9rem'
        },
        input: {
            width: '100%',
            padding: '12px',
            borderRadius: '8px',
            border: '1px solid transparent',
            backgroundColor: '#f5f7f9',
            fontSize: '1rem',
            transition: 'border-color 0.3s'
        },
        select: {
            width: '100%',
            padding: '12px',
            borderRadius: '8px',
            border: '1px solid transparent',
            backgroundColor: '#f5f7f9',
            fontSize: '1rem',
            appearance: 'none'
        }
    };


    const handleCopyReferralLink = () => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(referralLink)
                .then(() => {
                    setSnackbarMessage('Referral link copied to clipboard!');
                    setSnackbarSeverity('success');
                    setSnackbarOpen(true);
                })
                .catch(() => {
                    fallbackCopyTextToClipboard(referralLink);
                });
        } else {
            fallbackCopyTextToClipboard(referralLink);
        }
    };

    const fallbackCopyTextToClipboard = (text) => {
        const textArea = document.createElement('textarea');
        textArea.value = text;

        // Prevent scrolling to bottom
        textArea.style.position = 'fixed';
        textArea.style.top = 0;
        textArea.style.left = 0;
        textArea.style.width = '2em';
        textArea.style.height = '2em';
        textArea.style.padding = 0;
        textArea.style.border = 'none';
        textArea.style.outline = 'none';
        textArea.style.boxShadow = 'none';
        textArea.style.background = 'transparent';

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            const successful = document.execCommand('copy');
            setSnackbarMessage(successful ? 'Referral link copied!' : 'Failed to copy referral link');
            setSnackbarSeverity(successful ? 'success' : 'error');
        } catch (err) {
            setSnackbarMessage('Copy failed. Please copy manually.');
            setSnackbarSeverity('error');
        }

        setSnackbarOpen(true);
        document.body.removeChild(textArea);
    };


    return (
        <div className="health-record-container">
            {/* Main Content */}
            <div className={`health-record-main ${isMobile ? 'mobile' : ''}`}>
                {/* Sidebar */}

                <div className="health-record-sidebar">
                    <div className="sidebar-content">
                        {!isMobile && (
                            <div className="sidebar-logo">
                                <img src={logo} alt="ConnectHealthPro" />
                            </div>
                        )}
                        <ul className="sidebar-list">
                            {sidebarItems.map((item) => (
                                <li
                                    key={item.key}
                                    className={`sidebar-item ${selectedSidebarItem === item.key ? 'selected' : ''}`}
                                    onClick={() => handleSidebarItemClick(item.key)}
                                >
                                    <span className="sidebar-icon">{item.icon}</span>
                                    {item.text}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Main Content Area */}
                <div className="health-record-content">
                    {targetedAdsAll.length > 0 && selectedTabIndex !== 3 && (
                        <Box sx={{ mb: 3 }}>
                            <PromoBanner ads={targetedAdsAll} page={'All Locations'} />
                        </Box>
                    )}
                    {targetedAds.length > 0 && selectedTabIndex === 3 && (
                        <Box sx={{ mb: 3 }}>
                            <PromoBanner ads={targetedAds} page={'Allergies Screen'} />
                        </Box>
                    )}


                    {selectedSidebarItem === 'personalInfo' && (
                        <>
                            <div className="content-paper">
                                {/* Tabs */}
                                <div className="tabs-container">
                                    {tabLabels.map((tab, index) => (
                                        <div
                                            key={index}
                                            className={`tab ${selectedTabIndex === index ? 'selected' : ''}`}
                                            onClick={() => handleTabChange(index)}
                                        >
                                            <span className="tab-icon">{tab.icon}</span>
                                            {tab.label}
                                        </div>
                                    ))}
                                </div>

                                {/* Content for Personal Details Tab */}
                                {selectedTabIndex === 0 && (
                                    <>
                                        <div className="profile-header">
                                            <img
                                                src={profilePicture}
                                                alt="Profile"
                                                className="profile-avatar"
                                            />
                                            <div className="profile-text">
                                                <h2>{formData?.fullName}</h2>
                                                <p>{formData?.email}</p>
                                            </div>
                                        </div>

                                        <h3 className="section-title">Personal Information</h3>
                                        <div className="form-grid">
                                            <div className="form-group">
                                                <label>Title <span style={{ color: 'red' }}>*</span></label>
                                                <select
                                                    name="title"
                                                    value={formData?.title}
                                                    onChange={handleChange}
                                                    required
                                                >
                                                    <option value="">Select Title</option>
                                                    {titleOptions.map((title) => (
                                                        <option key={title} value={title}>{title}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <label>First Name <span style={{ color: 'red' }}>*</span></label>
                                                <input
                                                    type="text"
                                                    name="firstName"
                                                    value={formData?.firstName}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>Middle Name</label>
                                                <input
                                                    type="text"
                                                    name="middleName"
                                                    value={formData?.middleName}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>Last Name <span style={{ color: 'red' }}>*</span></label>
                                                <input
                                                    type="text"
                                                    name="lastName"
                                                    value={formData?.lastName}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>Gender <span style={{ color: 'red' }}>*</span></label>
                                                <select
                                                    name="gender"
                                                    value={formData?.gender}
                                                    onChange={handleChange}
                                                    required
                                                >
                                                    <option value="">Select Gender</option>
                                                    <option value="Male">Male</option>
                                                    <option value="Female">Female</option>
                                                    <option value="Other">Other</option>
                                                </select>
                                            </div>
                                            <div style={styles?.formGroup}>
                                                <label style={styles?.label}>Phone Number <span style={{ color: 'red' }}>*</span></label>
                                                <PhoneInput
                                                    value={formData?.phoneNumber || ''}
                                                    onChange={(value) => setFormData(prev => ({ ...prev, phoneNumber: value }))}
                                                    placeholder="Enter phone number"
                                                    selectStyle={{
                                                        padding: '12px',
                                                        borderRadius: '8px',
                                                        border: '1px solid transparent',
                                                        backgroundColor: '#f5f7f9',
                                                        fontSize: '1rem'
                                                    }}
                                                    inputStyle={{
                                                        padding: '12px',
                                                        borderRadius: '8px',
                                                        border: '1px solid transparent',
                                                        backgroundColor: '#f5f7f9',
                                                        fontSize: '1rem'
                                                    }}
                                                />
                                            </div>
                                            <div style={styles?.formGroup}>
                                                <label style={styles?.label}>Email Address <span style={{ color: 'red' }}>*</span></label>
                                                <input
                                                    type="email"
                                                    name="email"
                                                    value={formData?.email}
                                                    onChange={handleChange}
                                                    style={styles?.input}
                                                    required
                                                />
                                            </div>
                                            <div style={styles?.formGroup}>
                                                <label style={styles?.label}>Date of Birth <span style={{ color: 'red' }}>*</span></label>
                                                <DatePicker
                                                    selected={selectedDate}
                                                    onChange={handleDateChange}
                                                    dateFormat="dd/MM/yyyy"
                                                    placeholderText="DD/MM/YYYY"
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    maxDate={new Date()}
                                                    customInput={<input style={styles.input} />}
                                                    wrapperClassName="w-full"
                                                />
                                            </div>
                                            <div style={styles?.formGroup}>
                                                <label style={styles?.label}>Nationality</label>
                                                <select
                                                    name="geoNationality"
                                                    value={formData.geoNationality ? nationalities.find(n => n.name === formData.geoNationality)?.id || '' : ''}
                                                    onChange={async (e) => {
                                                        const val = parseInt(e.target.value) || null;
                                                        const selectedNat = nationalities.find(n => n.id === val);
                                                        // update nationality and reset downstream selections
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            geoNationality: selectedNat?.name || '',
                                                            stateId: null,
                                                            stateOfOrigin: '',
                                                            city: ''
                                                        }));
                                                        // fetch states for selected country
                                                        if (val) {
                                                            await getStates(val);
                                                        } else {
                                                            setStates([]);
                                                            setCities([]);
                                                        }
                                                    }}
                                                    style={styles?.select}
                                                >
                                                    <option value="">Select Nationality</option>
                                                    {nationalities.map((nat) => (
                                                        <option key={nat.id} value={nat.id}>{nat.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div style={styles?.formGroup}>
                                                <label style={styles?.label}>State </label>
                                                <select
                                                    name="geoState"
                                                    value={formData.geoState ? states.find(s => s.name === formData.geoState)?.id || '' : ''}
                                                    onChange={async (e) => {
                                                        const val = parseInt(e.target.value) || null;
                                                        const selectedState = states.find(s => s.id === val);
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            geoState: selectedState?.name || '',
                                                            stateOfOrigin: selectedState?.name || '',
                                                            city: ''
                                                        }));
                                                        // fetch cities for selected state
                                                        if (val) {
                                                            await getCities(val);
                                                        } else {
                                                            setCities([]);
                                                        }
                                                    }}
                                                    style={styles?.select}
                                                >
                                                    <option value="">Select State</option>
                                                    {states.map((state) => (
                                                        <option key={state.id} value={state.id}>{state.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div style={styles?.formGroup}>
                                                <label style={styles?.label}>Place of Birth <span style={{ color: 'red' }}>*</span></label>
                                                <input
                                                    type="text"
                                                    name="placeOfBirth"
                                                    value={formData?.placeOfBirth}
                                                    onChange={handleChange}
                                                    style={styles?.input}
                                                    required
                                                />
                                            </div>
                                            <div style={styles?.formGroup}>
                                                <label style={styles?.label}>City</label>
                                                {cities && cities.length > 0 ? (
                                                    <select
                                                        name="city"
                                                        value={formData?.city || ''}
                                                        onChange={(e) => setFormData(prev => ({ ...prev, city: e.target.value }))}
                                                        style={styles?.select}
                                                    >
                                                        <option value="">Select City</option>
                                                        {cities.map((c) => (
                                                            <option key={c.id || c.name} value={c.name}>{c.name}</option>
                                                        ))}
                                                    </select>
                                                ) : (
                                                    <input
                                                        type="text"
                                                        name="city"
                                                        value={formData?.city}
                                                        onChange={handleChange}
                                                        style={styles?.input}
                                                    />
                                                )}
                                            </div>

                                            <div style={styles?.formGroup}>
                                                <label style={styles?.label}>Marital Status</label>
                                                <select
                                                    name="maritalStatus"
                                                    value={formData?.maritalStatus}
                                                    onChange={handleChange}
                                                    style={styles?.select}
                                                >
                                                    <option value="">Select Status</option>
                                                    <option value="Single">Single</option>
                                                    <option value="Married">Married</option>
                                                    <option value="Divorced">Divorced</option>
                                                    <option value="Widowed">Widowed</option>
                                                </select>
                                            </div>



                                            {/* <div style={styles?.formGroup}>
                                                <label style={styles?.label}>National Identification Number</label>
                                                <input
                                                    type="text"
                                                    name="identificationNo"
                                                    value={formData?.nin}
                                                    onChange={handleChange}
                                                    placeholder="Enter NIN"
                                                    style={styles?.input}
                                                />
                                            </div> */}

                                            {/* ...rest of form fields... */}
                                        </div>
                                        <div style={{ textAlign: 'right', marginTop: '16px' }}>
                                            <Button
                                                variant="contained"
                                                color="success"
                                                onClick={handleSavePersonalInfo}
                                                disabled={savingStatus?.personalInfo}
                                                sx={{
                                                    px: 3,
                                                    py: 1.5,
                                                    borderRadius: '8px',
                                                    fontWeight: 600,
                                                    textTransform: 'none',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 1
                                                }}
                                            >
                                                {savingStatus?.personalInfo && (
                                                    <CircularProgress size={20} color="inherit" />
                                                )}
                                                {savingStatus?.personalInfo ? 'Saving...' : 'Save Personal Info'}
                                            </Button>
                                        </div>

                                    </>
                                )}


                            </div>
                        </>
                    )}
                    {selectedSidebarItem === 'referralLink' && (
                        <div className="content-paper">
                            {/* Referral Rewards Card */}
                            <div style={{ marginBottom: 24 }}>
                                {referralsLoading ? (
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: '24px',
                                        background: 'linear-gradient(135deg, #2e7d32 0%, #66bb6a 100%)',
                                        borderRadius: 12,
                                        boxShadow: '0 4px 6px rgba(46, 125, 50, 0.3)'
                                    }}>
                                        <CircularProgress size={24} sx={{ color: '#fff', mr: 2 }} />
                                        <span style={{ color: '#fff', fontSize: '16px' }}>Loading your referral stats...</span>
                                    </div>
                                ) : (
                                    <div style={{
                                        background: 'linear-gradient(135deg, #2e7d32 0%, #66bb6a 100%)',
                                        borderRadius: 12,
                                        padding: '24px',
                                        boxShadow: '0 4px 15px rgba(46, 125, 50, 0.4)',
                                        color: '#fff'
                                    }}>
                                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: 12 }}>
                                                <path d="M20 12C20 10.897 19.103 10 18 10H13V7C13 5.346 11.654 4 10 4H6C4.346 4 3 5.346 3 7V17C3 18.654 4.346 20 6 20H18C19.103 20 20 19.103 20 18V12ZM6 18C5.449 18 5 17.551 5 17V7C5 6.449 5.449 6 6 6H10C10.551 6 11 6.449 11 7V12H18V18H6Z" fill="white" />
                                                <path d="M21 8H20V6H21V8Z" fill="white" />
                                                <path d="M8 9H7V11H8V9Z" fill="white" />
                                            </svg>
                                            <div>
                                                <h3 style={{ margin: 0, fontSize: '20px', fontWeight: 'bold' }}>Referral Rewards Program</h3>
                                                <p style={{ margin: '4px 0 0 0', fontSize: '14px', opacity: 0.9 }}>
                                                    {referralsCount === 0
                                                        ? "Start earning by sharing your referral link!"
                                                        : referralsCount < 5
                                                            ? "Great start! Keep sharing to earn more rewards!"
                                                            : referralsCount < 10
                                                                ? "Amazing work! You're building a healthy community!"
                                                                : "Wow! You're a referral champion! ⭐"}
                                                </p>
                                            </div>
                                        </div>

                                        <div style={{
                                            display: 'grid',
                                            gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
                                            gap: 16,
                                            marginBottom: 16
                                        }}>
                                            <div style={{
                                                background: 'rgba(255, 255, 255, 0.15)',
                                                padding: '16px',
                                                borderRadius: 8,
                                                backdropFilter: 'blur(10px)',
                                                border: '1px solid rgba(255, 255, 255, 0.2)'
                                            }}>
                                                <div style={{ fontSize: '14px', opacity: 0.9, marginBottom: 4 }}>Total Referrals</div>
                                                <div style={{ fontSize: '32px', fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
                                                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: 8 }}>
                                                        <path d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z" fill="white" />
                                                    </svg>
                                                    {referralsCount}
                                                </div>
                                            </div>

                                            <div style={{
                                                background: 'rgba(255, 255, 255, 0.15)',
                                                padding: '16px',
                                                borderRadius: 8,
                                                backdropFilter: 'blur(10px)',
                                                border: '1px solid rgba(255, 255, 255, 0.2)'
                                            }}>
                                                <div style={{ fontSize: '14px', opacity: 0.9, marginBottom: 4 }}>Total Earnings</div>
                                                <div style={{ fontSize: '32px', fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
                                                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: 8 }}>
                                                        <path d="M21 18V19C21 20.1 20.1 21 19 21H5C3.89 21 3 20.1 3 19V5C3 3.9 3.89 3 5 3H19C20.1 3 21 3.9 21 5V6H12C10.89 6 10 6.9 10 8V16C10 17.1 10.89 18 12 18H21ZM12 16H22V8H12V16ZM16 13.5C15.17 13.5 14.5 12.83 14.5 12C14.5 11.17 15.17 10.5 16 10.5C16.83 10.5 17.5 11.17 17.5 12C17.5 12.83 16.83 13.5 16 13.5Z" fill="white" />
                                                    </svg>
                                                    ₦{(Number(referralsCount) * 50).toLocaleString()}
                                                </div>
                                                <div style={{ fontSize: '12px', opacity: 0.8, marginTop: 4 }}>₦50 per referral</div>
                                                <div style={{ fontSize: '12px', opacity: 0.85, marginTop: 12, paddingTop: 12, borderTop: '1px solid rgba(255, 255, 255, 0.3)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <span>Referral Code:</span>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                        <span style={{ fontWeight: 'bold', letterSpacing: '1px' }}>{userId}</span>
                                                        <button
                                                            onClick={() => {
                                                                navigator.clipboard.writeText(userId);
                                                                setSnackbarMessage('Referral code copied!');
                                                                setSnackbarSeverity('success');
                                                                setSnackbarOpen(true);
                                                            }}
                                                            style={{
                                                                background: 'none',
                                                                border: 'none',
                                                                cursor: 'pointer',
                                                                padding: 0,
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                opacity: 0.8,
                                                                transition: 'opacity 0.2s'
                                                            }}
                                                            onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
                                                            onMouseLeave={(e) => e.currentTarget.style.opacity = '0.8'}
                                                        >
                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z" fill="white" />
                                                            </svg>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {referralsCount > 0 && (
                                            <div style={{
                                                fontSize: '14px',
                                                opacity: 0.9,
                                                padding: '12px 16px',
                                                background: 'rgba(255, 255, 255, 0.15)',
                                                borderRadius: 8,
                                                border: '1px solid rgba(255, 255, 255, 0.2)',
                                                marginBottom: 16,
                                                textAlign: 'center',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: 8 }}>
                                                    <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="white" />
                                                </svg>
                                                Thank you for spreading health and wellness!
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>

                            {/* Referral Link Section */}
                            <div style={{
                                background: '#fff',
                                borderRadius: 12,
                                padding: '24px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                border: '1px solid #e0e0e0'
                            }}>
                                <h3 style={{
                                    fontSize: '18px',
                                    fontWeight: 'bold',
                                    color: '#2e7d32',
                                    marginBottom: 8,
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: 8 }}>
                                        <path d="M3.9 12C3.9 10.29 5.29 8.9 7 8.9H11V7H7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17H11V15.1H7C5.29 15.1 3.9 13.71 3.9 12ZM8 13H16V11H8V13ZM17 7H13V8.9H17C18.71 8.9 20.1 10.29 20.1 12C20.1 13.71 18.71 15.1 17 15.1H13V17H17C19.76 17 22 14.76 22 12C22 9.24 19.76 7 17 7Z" fill="#2e7d32" />
                                    </svg>
                                    Your Referral Link
                                </h3>
                                <p style={{ fontSize: '14px', color: '#6c757d', marginBottom: 16 }}>
                                    Share this link with friends and family to invite them to join ConnectHealthPro
                                </p>

                                {/* Referral Type Selector */}
                                <div style={{ marginBottom: 20 }}>
                                    <label style={{ fontSize: '14px', fontWeight: 'bold', color: '#495057', marginBottom: 8, display: 'block' }}>
                                        Select Referral Type
                                    </label>
                                    <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                                        <button
                                            onClick={() => setSelectedReferralType('platform')}
                                            style={{
                                                flex: 1,
                                                minWidth: '150px',
                                                padding: '12px 20px',
                                                borderRadius: 8,
                                                border: selectedReferralType === 'platform' ? '2px solid #2e7d32' : '2px solid #dee2e6',
                                                backgroundColor: selectedReferralType === 'platform' ? '#e7f5e9' : '#fff',
                                                color: selectedReferralType === 'platform' ? '#2e7d32' : '#6c757d',
                                                fontWeight: selectedReferralType === 'platform' ? 'bold' : 'normal',
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease',
                                                fontSize: '14px'
                                            }}
                                        >
                                            Citizens
                                        </button>
                                        <button
                                            onClick={() => setSelectedReferralType('practitioners')}
                                            style={{
                                                flex: 1,
                                                minWidth: '150px',
                                                padding: '12px 20px',
                                                borderRadius: 8,
                                                border: selectedReferralType === 'practitioners' ? '2px solid #2e7d32' : '2px solid #dee2e6',
                                                backgroundColor: selectedReferralType === 'practitioners' ? '#e7f5e9' : '#fff',
                                                color: selectedReferralType === 'practitioners' ? '#2e7d32' : '#6c757d',
                                                fontWeight: selectedReferralType === 'practitioners' ? 'bold' : 'normal',
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease',
                                                fontSize: '14px'
                                            }}
                                        >
                                            Health Practitioners
                                        </button>
                                    </div>
                                </div>

                                <div style={{
                                    background: '#f8f9fa',
                                    padding: '12px',
                                    borderRadius: 8,
                                    border: '1px solid #e0e0e0',
                                    marginBottom: 16,
                                    wordBreak: 'break-all'
                                }}>
                                    <input
                                        type="text"
                                        value={referralLink}
                                        readOnly
                                        aria-label="Referral link"
                                        onFocus={(e) => e.target.select()}
                                        style={{
                                            width: '100%',
                                            padding: '12px',
                                            borderRadius: '6px',
                                            border: '1px solid #dee2e6',
                                            backgroundColor: '#fff',
                                            fontSize: '14px',
                                            textAlign: 'center',
                                            color: '#495057'
                                        }}
                                    />
                                </div>

                                <Button
                                    onClick={handleCopyReferralLink}
                                    variant="contained"
                                    fullWidth
                                    sx={{
                                        backgroundColor: '#2e7d32',
                                        color: '#fff',
                                        fontWeight: 'bold',
                                        padding: '12px 24px',
                                        borderRadius: '8px',
                                        textTransform: 'none',
                                        fontSize: '16px',
                                        boxShadow: '0 2px 8px rgba(46, 125, 50, 0.3)',
                                        '&:hover': {
                                            backgroundColor: '#1b5e20',
                                            boxShadow: '0 4px 12px rgba(46, 125, 50, 0.4)',
                                        }
                                    }}
                                    startIcon={
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z" fill="white" />
                                        </svg>
                                    }
                                >
                                    Copy Referral Link
                                </Button>

                                <div style={{
                                    marginTop: 16,
                                    padding: '12px',
                                    background: '#e7f5e9',
                                    borderRadius: 8,
                                    border: '1px solid #c3e6cb'
                                }}>
                                    <p style={{
                                        fontSize: '13px',
                                        color: '#155724',
                                        margin: 0,
                                        textAlign: 'center'
                                    }}>
                                        💡 <strong>Tip:</strong> Share via WhatsApp, Email, or Social Media to maximize your earnings!
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {currentMedication && (
                    <div className="health-record-sidebar right">
                        <div className="medication-card">
                            <div className="medication-header">
                                <span>⚠️</span>
                                <h3>Current Medication</h3>
                            </div>
                            <p>Amlodipine 5mg daily for hypertension</p>
                            <p className="small">Your next dose: 11:00am</p>
                        </div>
                    </div>
                )}
            </div>

            {/* Snackbar Notification */}
            {
                snackbarOpen && (
                    <div className={`snackbar ${snackbarSeverity}`}>
                        {snackbarMessage}
                        <button onClick={handleSnackbarClose}>×</button>
                    </div>
                )
            }



            <style jsx>{`
                .health-record-container {
                    display: flex;
                    flex-direction: column;
                    min-height: 100vh;
                    background-color: #eef2f5;
                    font-family: 'Inter', sans-serif;
                }
                
                .health-record-header {
                    padding: 24px;
                    padding-bottom: ${isMobile ? '8px' : '16px'};
                    padding-top: ${isMobile ? '16px' : '24px'};
                    background-color: #eef2f5;
                }
                
                .health-record-header h1 {
                    color: #212529;
                    font-weight: bold;
                    font-size: 1.25rem;
                }
                
                .health-record-main {
                    display: flex;
                    flex-grow: 1;
                    padding: 0 24px 24px;
                    gap: 24px;
                }
                
                .health-record-main.mobile {
                    flex-direction: column;
                }
                
                .health-record-sidebar {
                    flex-basis: 20%;
                    width: 100%;
                }
                
                .health-record-sidebar.right {
                    flex-basis: 20%;
                }
                
                .sidebar-content {
                    padding: 8px;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    background-color: #ffffff;
                    border-radius: 12px;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                }
                
                .sidebar-logo {
                    margin-bottom: 16px;
                }
                
                .sidebar-logo img {
                    width: 100%;
                }
                
                .sidebar-list {
                    flex-grow: 1;
                    list-style: none;
                    padding: 0;
                    margin: 0;
                }
                
                .sidebar-item {
                    display: flex;
                    align-items: center;
                    padding: 12px 16px;
                    border-radius: 8px;
                    margin-bottom: 8px;
                    cursor: pointer;
                    background-color: transparent;
                    transition: background-color 0.2s;
                }
                
                .sidebar-item.selected {
                    background-color: rgba(40, 167, 69, 0.1);
                    color: #28a745;
                }
                
                .sidebar-item:hover {
                    background-color: rgba(40, 167, 69, 0.05);
                }
                
                .sidebar-icon {
                    margin-right: 12px;
                }
                
                .health-record-content {
                    flex-basis: 80%;
                    width: 100%;
                }
                
                .content-paper {
                    padding: ${isMobile ? '16px' : '24px'};
                    margin-bottom: 24px;
                    background-color: #ffffff;
                    border-radius: 12px;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                }
                
                .tabs-container {
                    display: flex;
                    border-bottom: 1px solid #e0e0e0;
                    margin-bottom: 16px;
                    overflow-x: auto;
                }
                
                .tab {
                    padding: 12px 16px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    color: #6c757d;
                    font-weight: 600;
                    border-bottom: 2px solid transparent;
                    white-space: nowrap;
                }
                
                .tab.selected {
                    color: #28a745;
                    border-bottom: 2px solid #28a745;
                }
                
                .tab-icon {
                    margin-right: 8px;
                }
                
                .profile-header {
                    display: flex;
                    align-items: center;
                    margin-bottom: 24px;
                    flex-wrap: wrap;
                    gap: ${isMobile ? '16px' : '0'};
                }
                
                .profile-avatar {
                    width: 80px;
                    height: 80px;
                    border-radius: 50%;
                    margin-right: ${isMobile ? '0' : '16px'};
                    margin-bottom: ${isMobile ? '16px' : '0'};
                    object-fit: cover;
                }
                
                .profile-text {
                    flex-grow: 1;
                    text-align: ${isMobile ? 'center' : 'left'};
                }
                
                .profile-text h2 {
                    font-size: 1.25rem;
                    color: #212529;
                    margin: 0;
                }
                
                .profile-text p {
                    font-size: 0.9rem;
                    color: #6c757d;
                    margin: 4px 0 0 0;
                }
                
                .section-title {
                    font-size: 1.25rem;
                    color: #212529;
                    margin-bottom: 16px;
                    font-weight: 600;
                }
                
                .form-grid {
                    display: grid;
                    grid-template-columns: ${isMobile ? '1fr' : '1fr 1fr'};
                    gap: 24px;
                    margin-bottom: 24px;
                }
                
                .form-group {
                    margin-bottom: 16px;
                }
                
                .form-group label {
                    display: block;
                    margin-bottom: 8px;
                    color: #6c757d;
                    font-size: 0.9rem;
                }
                
                .form-group input,
                .form-group select {
                    width: 100%;
                    padding: 12px;
                    border-radius: 8px;
                    border: 1px solid transparent;
                    background-color: #f5f7f9;
                    font-size: 1rem;
                    transition: border-color 0.3s;
                }
                
                .form-group input:focus,
                .form-group select:focus {
                    border-color: #28a745;
                    outline: none;
                }
                
                .form-group select {
                    appearance: none;
                    background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%236c757d%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E");
                    background-repeat: no-repeat;
                    background-position: right 12px center;
                    background-size: 12px;
                }
                
                .medication-card {
                    padding: 16px;
                    background-color: #ffffff;
                    border-radius: 12px;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                }
                
                .medication-header {
                    display: flex;
                    align-items: center;
                    margin-bottom: 8px;
                }
                
                .medication-header span {
                    color: #dc3545;
                    margin-right: 8px;
                }
                
                .medication-header h3 {
                    font-weight: bold;
                    color: #dc3545;
                    margin: 0;
                }
                
                .medication-card p {
                    color: #6c757d;
                    margin: 4px 0;
                    font-size: 0.9rem;
                }
                
                .medication-card .small {
                    font-size: 0.8rem;
                }
                
                .snackbar {
                    position: fixed;
                    bottom: 20px;
                    left: 50%;
                    transform: translateX(-50%);
                    padding: 12px 24px;
                    border-radius: 4px;
                    color: white;
                    background-color: #28a745;
                    box-shadow: 0 2px 10px rgba(0,0,0,0.2);
                    z-index: 1000;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    min-width: 300px;
                }
                
                .snackbar.error {
                    background-color: #dc3545;
                }
                
                .snackbar.info {
                    background-color: #17a2b8;
                }
                
                .snackbar button {
                    background: none;
                    border: none;
                    color: white;
                    cursor: pointer;
                    margin-left: 16px;
                }
            `}</style>
        </div >
    );
}

export default HealthRecord;